import * as React from 'react';
export const websiteSvg = React.forwardRef(function websiteSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm7.298 11.86.004.001v-.001l.001-.002a6.002 6.002 0 0 0 0-11.716V.14L7.301.139 7.298.14a6.022 6.022 0 0 0-2.595 0L4.698.139v.003a6.002 6.002 0 0 0-.001 11.716v.002l.001.001.005-.002a6.021 6.021 0 0 0 2.595 0Zm-.802-1.286A4.668 4.668 0 0 1 6 10.6c-.167 0-.333-.009-.496-.026a16.417 16.417 0 0 1-.238-.794A15.18 15.18 0 0 1 4.74 6.6h2.52a15.178 15.178 0 0 1-.526 3.18c-.082.3-.164.567-.238.794Zm-2.356-.366-.031-.113a16.33 16.33 0 0 1-.57-3.495h-2.1a4.605 4.605 0 0 0 2.7 3.608ZM1.439 5.4h2.1a16.33 16.33 0 0 1 .6-3.608A4.605 4.605 0 0 0 1.44 5.4Zm4.065-3.974c-.074.227-.156.494-.238.794A15.18 15.18 0 0 0 4.74 5.4h2.52a15.178 15.178 0 0 0-.526-3.18c-.082-.3-.164-.567-.238-.794a4.652 4.652 0 0 0-.992 0Zm2.356.366.032.113c.252.926.508 2.155.57 3.495h2.1A4.605 4.605 0 0 0 7.86 1.792ZM10.561 6.6a4.605 4.605 0 0 1-2.7 3.608l.03-.113a16.33 16.33 0 0 0 .57-3.495h2.1Z',
      clipRule: 'evenodd',
    }),
  );
});
websiteSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var website = {
  category: 'icon',
  colorable: true,
  name: 'website',
  svg: websiteSvg,
};
